import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#18a0fb",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18" }), /* @__PURE__ */ _jsx("path", { d: "m9 12 2 2 4-4" })]
	})
});
export default SvgCheckCircleIcon;
